import Vue from 'vue';
import CryptoJS from 'crypto-js';
export default {
  data() {
    return {
      roleId: '',
      userId: '',
      userFullName: '',
      searchFromDate: '',
      searchToDate: '',
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
      searchModal: false,
      userAllRoles: [],
      //row 1
      hospitalAssignmentCount: '',
      allWorkingTime: '',
      callsCount: '',
      responseTime: '',
      //row 2
      loginLogoutTableHeader: [
        { text: 'تاریخ ورود', value: 'loginDate', align: 'start' },
        { text: 'تاریخ خروج', value: 'logoutDate', align: 'start' },
        { text: 'مدت زمان', value: 'duration', align: 'center' },
      ],
      loginLogoutTableItems: [],
      //pie rank
      pieRankChartOption: {
        colors: [],
        chart: {
          renderTo: 'dashboardQCPieRankChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 90,
            depth: 50,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'اولویت ها',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //row 3
      dashboardIMG: require('@/assets/images/dashboard800Image.png'),
      outOfServiceHospitalCount: null,
      userLoginCount: null,
      hospitalsColumnChartOptions: {
        chart: {
          type: 'column',
          height: '240px',
        },
        title: {
          text: '',
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        exporting: {
          chartOptions: {
            xAxis: [
              {
                labels: {
                  rtl: true,
                  style: {
                    fontSize: '7px',
                    color: '#000000',
                    direction: 'ltr',
                    textAlign: 'right',
                    width: '170px',
                    wordWrap: 'break-word',
                  },
                  rotation: -45,
                },
                tickLength: 0,
              },
            ],
          },
        },
        xAxis: {
          type: 'category',
          useHTML: true,
          reversed: true,
          labels: {
            style: {
              fontSize: '9px',
              color: '#000000',
              textAlign: 'right',
              width: '120px',
              wordWrap: 'break-word',
            },
            useHTML: true,
          },
          tickLength: 0,
        },
        yAxis: {
          title: {
            text: '',
          },
          opposite: false,
          useHTML: true,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            color: '#6CBB5F',
            useHTML: true,
            dataLabels: {
              enabled: false,
              format: '{point.text}',
              x: 2,
              style: {
                fontWeight: 'normal',
                color: '#000000',
                fontSize: '12px',
              },
              useHTML: true,
            },
          },
          column: {
            depth: 25,
          },
        },
        tooltip: {
          useHTML: true,
          headerFormat: '<span class="tooltipHeader" style="color:#ffffff;"></span>',
          pointFormat:
            '<div class="tooltipPointWrapper">‎' +
            '<span style="color:#ffffff">{point.name}</span>: <span  style="color:#ffffff">{point.text}</span></div>',
        },
        series: [
          {
            name: 'بیمارستان',
            keys: ['name', 'y', 'text'],
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    readyDashboard: function (data) {
      this.hospitalAssignmentCount = data.hospitalAssignmentCount
        ? data.hospitalAssignmentCount.valueLong
        : '-';
      this.callsCount = data.callsCount ? data.callsCount.valueLong : '-';
      let duration = Math.round(data.workingHours.valueDouble);
      duration = duration * 1000;
      this.allWorkingTime = this.msToTime(duration);

      let duration1 = Math.round(data.responseTime.valueDouble);
      duration1 = duration1 * 1000;
      this.responseTime = this.msToTime(duration1);
      //row2
      //pie rank chart
      let pieChartData = JSON.parse(JSON.stringify([]));
      let pieChartTempArray = JSON.parse(JSON.stringify([]));
      pieChartTempArray = JSON.parse(JSON.stringify(data.missionsWithHospitalByRank));
      for (let i = 0; i < pieChartTempArray.length; i++) {
        if (
          pieChartTempArray[i].title == 'سفید' &&
          !this.pieRankChartOption.colors.includes('#EBEBEB')
        ) {
          this.pieRankChartOption.colors.push('#EBEBEB');
        } else if (
          pieChartTempArray[i].title == 'سبز' &&
          !this.pieRankChartOption.colors.includes('#2EBA7F')
        ) {
          this.pieRankChartOption.colors.push('#2EBA7F');
        } else if (
          pieChartTempArray[i].title == 'زرد' &&
          !this.pieRankChartOption.colors.includes('#FFBD55')
        ) {
          this.pieRankChartOption.colors.push('#FFBD55');
        } else if (
          pieChartTempArray[i].title == 'قرمز' &&
          !this.pieRankChartOption.colors.includes('#DA6757')
        ) {
          this.pieRankChartOption.colors.push('#DA6757');
        }
        pieChartData.push({
          name: pieChartTempArray[i].title,
          y: pieChartTempArray[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData = JSON.parse(JSON.stringify(pieChartData));
      this.pieRankChartOption.series[0].data = [];
      this.pieRankChartOption.series[0].data = pieChartData;
      //row 3
      this.outOfServiceHospitalCount = data.outOfServiceHospitalCount
        ? data.outOfServiceHospitalCount.valueLong
        : '-';
      this.userLoginCount = data.userLoginCount ? data.userLoginCount.valueLong : '-';
      //column chart
      let coluumnHospitalChartData = JSON.parse(JSON.stringify([]));
      let coluumnHospitalTempArray = JSON.parse(JSON.stringify([]));
      coluumnHospitalTempArray = JSON.parse(JSON.stringify(data.assignedHospitalList));
      for (let i = 0; i < coluumnHospitalTempArray.length; i++) {
        coluumnHospitalChartData.push({
          name: coluumnHospitalTempArray[i].title,
          y: coluumnHospitalTempArray[i].valueLong,
          text: coluumnHospitalTempArray[i].valueLong.toString(),
        });
      }
      coluumnHospitalChartData = JSON.parse(JSON.stringify(coluumnHospitalChartData));
      this.hospitalsColumnChartOptions.series[0].data = [];
      this.hospitalsColumnChartOptions.series[0].data = coluumnHospitalChartData;
    },
    readyLoginLogoutData: function (data) {
      this.loginLogoutTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let loginDate = '-';
        let logoutDate = '-';
        let duration = Math.round(data[i].duration);
        duration = duration * 1000;
        if (data[i].loginDate) {
          loginDate = Vue.moment(data[i].loginDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].logoutDate) {
          logoutDate = Vue.moment(data[i].logoutDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        this.loginLogoutTableItems.push({
          loginDate: loginDate,
          logoutDate: logoutDate,
          duration: this.msToTime(duration),
        });
      }
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    backToReport: function () {
      this.$router.push({ name: 'qcUsersForQCReport' });
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.getUserRoleList();
      this.searchModal = true;
    },
    search: function () {
      this.searchModal = false;
      this.getQCUserAdmissionDashboardFunction(this.searchFromDate, this.searchToDate, this.userId);
      this.getQCUsersLoginLogoutReportFunction(this.searchFromDate, this.searchToDate, this.userId);
    },
    cancelSearch: function () {
      this.searchModal = false;
    },
    showAllLoginLogout: function () {
      let roleId = this.roleId.toString();
      let encryptRoleId = CryptoJS.AES.encrypt(roleId, 'f9rr8Y2D96Klh87N').toString();
      let userId = this.userId.toString();
      let encryptUserId = CryptoJS.AES.encrypt(userId, 'f9rr8Y2D96Klh87N').toString();
      let id =
        encryptRoleId +
        '$$' +
        encryptUserId +
        '$$' +
        this.userFullName +
        '$$' +
        this.searchFromDate +
        '$$' +
        this.searchToDate;
      this.$router.push({ name: 'user115AllLoginLogout', params: { id: id } });
    },
  },
};
